import './OurApp.css';
import Nav from './Nav';
import Footer from './Footer';
import ScaleFrame from './ScaleFrame';
import { SectionSeamUp, SectionSeamDown } from './SectionSeam';
import pot from '../assets/cutouts/pot.png';
import app1 from '../assets/cutouts/app1.png';
import app2 from '../assets/cutouts/app2.png';
import app3 from '../assets/cutouts/app3.png';
import app4 from '../assets/cutouts/app4.png';
import artwork from '../assets/cutouts/artwork.png';

const STEAM_WORDS = [
  { word: 'IV Score', left: 291, rotate: 15, flip: true},
  { word: 'Recipes', left: 404, rotate: 10, flip: true},
  { word: 'Nurtition Tracker', left: 516, rotate: 5, flip: true},
  { word: 'Social Media', left: 659, rotate: -5 , flip: false},
  { word: 'Viggie The Vegan', left: 779, rotate: -10 , flip: false},
  { word: 'Food Scanner', left: 899, rotate: -15, flip: false},
];

function OurApp() {
  return (
    <ScaleFrame>
      <section className="OurApp-panel OurApp-hero">
        <Nav />

        <h1 className="OurApp-comingSoon">Coming Soon</h1>


        {/**
         * A lot of the SVGs looked a bit off based on the Figma design. It's fine for now
         * but making a note of this for future developers and AI Agents in case 
         * it is requested to match the SVG position and orientation exactly like 
         * the Figma design
         */}

        <svg className="OurApp-heading OurApp-heading--cooking" viewBox="0 0 1100 220">
          <path id="cookingArc" d="M 40 190 Q 550 10 1060 190" fill="none" />
          <text>
            <textPath href="#cookingArc" startOffset="50%" textAnchor="middle">What We&rsquo;re Cooking Up</textPath>
          </text>
        </svg>

        <img className="OurApp-pot" src={pot} alt="Cooking pot" />

        <div className="OurApp-steam">
          {STEAM_WORDS.map(({ word, left, rotate, flip }, i) => (
            <svg
              key={word}
              className="OurApp-steamWord"
              style={{ left: `${left}px`, transform: `rotate(${rotate}deg)` }}
              viewBox="0 0 320 750"
            >
              <path
                id={`steamArc-${i}`}
                d={flip ? 'M 230 700 Q 20 300 160 10' : 'M 160 10 Q 300 300 90 700'}
                //d={flip ? 'M 160 10 Q 20 300 230 700' : 'M 160 10 Q 300 300 90 700'}
                fill="none"
              />
              <text>
                <textPath href={`#steamArc-${i}`} 
                startOffset={flip ? '100%' : '0'}
                textAnchor={flip?"end" : "start"}>{word}</textPath>
              </text>
            </svg>
          ))}
        </div>
      </section>

      <SectionSeamDown />
      <SectionSeamUp />

      <section className="OurApp-panel OurApp-connect">
        <svg className="OurApp-heading OurApp-heading--connect" viewBox="0 0 820 200">
          <path id="connectArc" d="M 15 155 Q 410 -20 805 155" fill="none" />
          <text>
            <textPath href="#connectArc" startOffset="4">Connect with others</textPath>
          </text>
        </svg>

        <img className="OurApp-phone OurApp-phone--1" src={app1} alt="App dashboard feed" />
        <img className="OurApp-phone OurApp-phone--2" src={app2} alt="App user profile" />

        <p className="OurApp-copy OurApp-copy--connect">
          Follow Vegan Influencers, share your Vegan experiences, explore inspiring stories, recipes, and insights from members of the Insane Vegan community.
        </p>
      </section>

      <SectionSeamDown />
      <SectionSeamUp />

      <section className="OurApp-panel OurApp-scan">
        <svg className="OurApp-heading OurApp-heading--nutrition" viewBox="0 0 680 200">
          <path id="nutritionArc" d="M 10 155 Q 340 -20 670 155" fill="none" />
          <text>
            <textPath href="#nutritionArc" startOffset="4">Track your nutrition</textPath>
          </text>
        </svg>
        <svg className="OurApp-heading OurApp-heading--scan" viewBox="0 0 680 260">
          <path id="scanArc" d="M 10 220 Q 340 70 670 220" fill="none" />
          <text>
            <textPath href="#scanArc" startOffset="4">Scan your meals</textPath>
          </text>
        </svg>

        <img className="OurApp-phone OurApp-phone--3" src={app3} alt="IV scanner scanning a bowl of food" />
        <img className="OurApp-phone OurApp-phone--4" src={app4} alt="Food details showing calories and vegan score" />

        <p className="OurApp-copy OurApp-copy--scan">
          Stay on top of your Vegan journey by scanning your meals and get
          instant details on calories, nutrients, and your Insane Vegan "IV" Score.
        </p>
      </section>

      <SectionSeamDown />
      <SectionSeamUp />

      <section className="OurApp-panel OurApp-score">
        <svg className="OurApp-heading OurApp-heading--score" viewBox="0 0 680 200">
          <path id="scoreArc" d="M 10 155 Q 340 90 670 155" fill="none" />
          <text>
            <textPath href="#scoreArc" startOffset="50%" textAnchor="middle">IV Score</textPath>
          </text>
        </svg>
        <img
          className="OurApp-artwork"
          src={artwork}
          alt="Viggie the mascot evolving from a mild green pepper into a spicy red chili as IV Score increases"
        />
        <p className="OurApp-copy OurApp-copy--score">
          Your IV Score is your progress meter, and Viggie the Vegan levels up with you as your IV Score grows. 
          <br></br>
          <br></br>
          Viggie evolves from a seed to a mellow green pepper into a full red-hot chili pepper. The more consistent you are, the spicier Viggie gets.
        </p>

        <Footer />
      </section>
    </ScaleFrame>
  );
}

export default OurApp;
